import {
  AnneeFormationLibelle,
  BaseCalculLibelle,
  ContratAvenantGroupLibelle,
  ModalitePedagogiqueLibelle,
  LieuMobiliteLibelle,
  ConditionRealisationLibelle,
  RegimeSocialLibelle,
  StatutApprentiLibelle,
  TypeQualificationLibelle,
} from '@/features/domaine/types/opco/Demande/CAPP/index'
import { objectToDropdownItems } from '@/features/interface/shared/tools'

export const regimeSocialItems = objectToDropdownItems(RegimeSocialLibelle)
export const baseCalculItems = objectToDropdownItems(BaseCalculLibelle)
export const anneeFormationItems = objectToDropdownItems(AnneeFormationLibelle)
export const contratAvenantGroupItems = objectToDropdownItems(ContratAvenantGroupLibelle)
export const modalitePedagogiqueItems = objectToDropdownItems(ModalitePedagogiqueLibelle)
export const statutApprentiItems = objectToDropdownItems(StatutApprentiLibelle)
export const typeQualificationItems = objectToDropdownItems(TypeQualificationLibelle)
export const lieuMobiliteItems = objectToDropdownItems(LieuMobiliteLibelle)
export const conditionRealisationItems = objectToDropdownItems(ConditionRealisationLibelle)
